// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const limeKiln = defineModel({
  id: "lime-kiln",
  batchId: "future",
  name: "Lime kiln",
  tags: ["building","lime","kiln","low-poly","age-of-mcp","future"],
  summary: "Burns limestone or chalk into lime — mortar, flux, glass and whitewash all start here.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.5, 0.72, 0.5, 12), color: "#8d8678", position: [0, 0.39, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.775, 0.475, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.775, 0.475, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.775, 0.475, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.775, 0.475, 0.775] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.5, 0.72, 1, 12), color: "#8d8678", position: [0, 0.64, 0] },
      { geometry: new THREE.TorusGeometry(0.6912, 0.045, 6, 14), color: "#6c665a", position: [0, 0.36, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.5795, 0.04, 6, 14), color: "#6c665a", position: [0, 0.76, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.775, 0.75, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.775, 0.75, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.775, 0.75, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.775, 0.75, 0.775] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.5, 0.72, 1.15, 12), color: "#8d8678", position: [0, 0.715, 0] },
      { geometry: new THREE.TorusGeometry(0.6912, 0.045, 6, 14), color: "#6c665a", position: [0, 0.393, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.5795, 0.04, 6, 14), color: "#6c665a", position: [0, 0.853, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.58, 0.4, 12), color: "#7a4a36", position: [0, 1.49, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.34, 0.07), color: "#2c2a28", position: [0, 0.33, 0.648] },
      { geometry: new THREE.CylinderGeometry(0.15, 0.15, 0.07, 8, 1, false, 0, 3.141593), color: "#2c2a28", position: [0, 0.5, 0.648], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.26, 0.3, 8), color: "#dcd6c4", position: [-0.72, 0.15, 0.5] },
      { geometry: new THREE.ConeGeometry(0.22, 0.26, 8), color: "#2c2a28", position: [0.74, 0.13, 0.5] },
    ] },
  ],
  animations: [],
});
